import { Button, ConfigProvider, Form, Image, Input, Typography } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "wouter";
import {
  GetWarrantyDetails,
  UpdateWarrantyDetails,
} from "../../../redux/actions/warranty/warranties-action";
import { ProjectUrl } from "../../../env";
import { EditOutlined, LeftOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const WarrantyDetails = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Step 1: Create a loading state

  const { warrantyId } = useParams();
  console.log("warrantyId is:", warrantyId);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [images, setImages] = useState([]);
  useEffect(() => {
    dispatch(GetWarrantyDetails({ id: warrantyId })).then((response) => {
      const data = response?.payload?.data?.data || {};
      console.log("response", response?.payload?.data?.data);
      form.setFieldsValue({
        vehicleRegistrationNumber: data.vehicleRegistrationNumber || "",
        vehicleBrand: data.carMake || "",
        vehicleModel: data.carModel || "",
        customerName: data.customerName || "",
        customerEmail: data.customerEmail || "",
        ppfRollNumber: data.ppfRollNumber || "",
        otherPpfRollNumbers: data.ppfRollNumberPartial || "",
        detailerName: data.detailerName || "",
        detailerPhoneNo: data.detailerPhoneNo || "",
        detailerEmail: data.detailerEmail || "",
        applicationDate: data.applicationDate || "",
        totalSqftUsed: data.totalSqftUsed || "",
        variantUsed: data.variantUsed || "",
        partialVariant: data.partialVariant || "",
        carColor: data.carColor || "",
        warrantyStartDate: data.warrantyStartDate || "",
        warrantyEndDate: data.warrantyEndDate || "",
        partialSqftUsed: data.partialSqftUsed || "",
        customerPhoneNo: data.customerPhoneNo || "",
      });
      setImages(data.images || []);
    });
  }, [dispatch, warrantyId]);

  const handleSubmit = (values) => {
    const payload = {
      // ppfRollNumber: values.ppfRollNumber, // get from form field
      updateWarrantyDto: {
        customerName: values.customerName,
        customerEmail: values.customerEmail,
        customerPhoneNo: values.customerPhoneNo,
      },
      warrantyId,
    };
    setIsLoading(true);
    dispatch(UpdateWarrantyDetails(payload)).then((res) => {
      setIsLoading(false);
      if (!res.error) {
        setIsEditing(false);

        // Optional: refetch updated warranty details
        dispatch(GetWarrantyDetails({ id: warrantyId })).then((response) => {
          const data = response?.payload?.data?.data || {};
          form.setFieldsValue({
            customerName: data.customerName || "",
            customerEmail: data.customerEmail || "",
            customerPhoneNo: data.customerPhoneNo || "",
          });
        });
      }
    });
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            titleMarginBottom: 0,
            titleMarginTop: 0,
          },
        },
      }}
    >
      <div className="flex flex-row items-center justify-between pb-12">
        <div className="flex items-center gap-2 ">
          <LeftOutlined
            className="text-xl font-bold cursor-pointer"
            onClick={() => window.history.back()}
          />

          <Title level={2} className="text-start">
            Warranty Details
          </Title>
        </div>
        {!isEditing && (
          <Button
            type="primary"
            className="flex w-[8%] items-center gap-2 rounded-md"
            onClick={() => setIsEditing(true)}
          >
            Edit <EditOutlined style={{ fontSize: "16px" }} />
          </Button>
        )}
      </div>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="w-full p-10 rounded-lg shadow-2xl"
      >
        <div className="flex flex-wrap items-center">
          <Form.Item
            className="w-1/3 px-2"
            label="Vehicle Registration Number Or Chasis Number"
            name="vehicleRegistrationNumber"
          >
            <Input
              placeholder="Vehicle Registration Number"
              disabled
              className="uppercase"
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Vehicle Brand"
            name="vehicleBrand"
          >
            <Input
              placeholder="Vehicle Brand"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Vehicle Model"
            name="vehicleModel"
          >
            <Input
              placeholder="Vehicle Model"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Vehicle Color"
            name="carColor"
          >
            <Input
              placeholder="Vehicle Color"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Customer Name"
            name="customerName"
          >
            <Input
              placeholder="Customer Name"
              className="text-black"
              // disabled
              disabled={!isEditing}
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Customer Email"
            name="customerEmail"
          >
            <Input
              placeholder="Customer Email"
              // disabled
              disabled={!isEditing}
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Customer Phone No."
            name="customerPhoneNo"
          >
            <Input
              placeholder="Customer Phone No."
              maxLength={10}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault(); // blocks non-numeric input
                }
              }}
              // disabled
              disabled={!isEditing}
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Detailer Studio Name"
            name="detailerName"
          >
            <Input
              placeholder="Applicator's Name"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Detailer Studio Email"
            name="detailerEmail"
          >
            <Input
              placeholder="Detailer Studio Email"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Detailer Studio Phone No"
            name="detailerPhoneNo"
          >
            <Input
              placeholder="Applicator's Phone No"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="PPF Roll Number"
            name="ppfRollNumber"
          >
            <Input
              placeholder="PPF Roll Number"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Total SQFT used"
            name="totalSqftUsed"
          >
            <Input
              placeholder="Total SQFT used"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item className="w-1/3 px-2" label="Variant" name="variantUsed">
            <Input
              placeholder="Variant Used"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Roll Numbers of other PPF used partially"
            name="otherPpfRollNumbers"
          >
            <Input
              placeholder="Roll Numbers of other PPF used partially"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Partial SQFT used"
            name="partialSqftUsed"
          >
            <Input
              placeholder="Partial SQFT used"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Variant of other PPF used partially"
            name="partialVariant"
          >
            <Input
              placeholder="Variant of other PPF used partially"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Application Date"
            name="applicationDate"
          >
            <Input
              placeholder="Application Date"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Warranty Start Date"
            name="warrantyStartDate"
          >
            <Input
              placeholder="Warranty Start Date"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
          <Form.Item
            className="w-1/3 px-2"
            label="Warranty End Date"
            name="warrantyEndDate"
          >
            <Input
              placeholder="Warranty End Date"
              disabled
              style={{ color: "black" }}
            />
          </Form.Item>
        </div>
        <div className="p-16 border border-black border-dashed rounded-lg">
          <div className="flex flex-wrap gap-8">
            {images.map((item, index) => (
              <Image
                width={200}
                height={200}
                className="object-cover border rounded-lg"
                src={`${ProjectUrl}/${item}`}
                key={index}
              />
            ))}
          </div>
        </div>
        {isEditing && (
          <div className="flex justify-end gap-2 mt-4">
            <Button
              type="primary"
              className="w-[8%] rounded-md"
              htmlType="submit"
              loading={isLoading}
            >
              Save
            </Button>
            <Button
              className="w-[8%] rounded-md border border-black"
              onClick={() => {
                setIsEditing(false);
                form.resetFields();
              }}
            >
              Cancel
            </Button>
          </div>
        )}
      </Form>
    </ConfigProvider>
  );
};

export default WarrantyDetails;
